import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import store from '../../store';
import {
	solarActivityLevelOptions,
	solarShadowLevelOptions,
} from '../solarSectionConfig';
import {
	selectSolarActivityLevel, selectSolarActivityLevelIsSatisfied,
	selectSolarDimmProfile, selectSolarDimmProfileIsSatisfied,
	selectSolarShadowLevel,
	selectSolarShadowLevelIsSatisfied
} from '../solarSelectors';
import {solarDimmProfileOptions} from '../dimProfiles';
import {getProductData} from '../../util/getProductData';
import {getFeature} from '../../util/values';

@customElement('solar-settings-panel')
export class SolarSettingsPanel extends connect(store)(LitElement) {

	static styles = css`
		:host {
			width: 350px;
		}
		.solarSettingsPanel {
			display: flex;
			flex-direction: column;
			gap: var(--padding);
			margin-bottom: 120px;
		}


	`;



	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	dimmProfileCanBeSelected(state, id) {
		return true;
		/*
		return selectSolarActivityLevel(state) !== 'none'
			? ['profile0', 'profile1', 'profile2'].includes(id) : true;
		 */
	}
	activityLevelCanBeSelected(state, id) {
		const dimmProfile = selectSolarDimmProfile(state);
		if (dimmProfile === 'profile3' || dimmProfile === 'profile4' || dimmProfile === 'profile5') {
			return id === 'none';
		} else {
			return true;
		}
	}
	stateChanged(state) {
		this.state = state;
		this.translations = state.productData.translations;
		this.productData = state.productData.productData;
		this.features = state.featureModel.data.features ?? [];
		this.region = state.status.region;
		this.lang = state.status.lang;
		this.loggedIn = state.userProfile.data.loggedIn;

		this.widgets = [
			html`
			<list-select
				.title=${{
				de: 'Dimmprofil',
				en: 'Dimmprofile',
				fr: 'Profil de gradation'
			}}
				.options=${solarDimmProfileOptions}
				action='solar/setSolarDimmProfile'
				.selected=${selectSolarDimmProfile}
				.canBeSelected=${this.dimmProfileCanBeSelected}
				.isSatisfied=${selectSolarDimmProfileIsSatisfied}></list-select>
			<list-select
				.title=${{
				de: 'Bewegungsmelder',
				en: 'Motion Sensor',
				fr: 'Détecteur de mouvement'
			}}
				.options=${solarActivityLevelOptions}
				action='solar/setSolarActivityLevel'
				.selected=${selectSolarActivityLevel}
				.canBeSelected=${this.activityLevelCanBeSelected}
				.isSatisfied=${selectSolarActivityLevelIsSatisfied}></list-select>
			${when(this.loggedIn, () => html`
			<list-select
				.title=${{
					de: 'Verschattung',
					en: 'Shading',
					fr: 'Ombrage'
				}}
				.options=${solarShadowLevelOptions}
				action='solar/setSolarShadowLevel'
				.selected=${selectSolarShadowLevel}
				.canBeSelected=${() => true}
				.isSatisfied=${selectSolarShadowLevelIsSatisfied}>
			</list-select>`)}
			<feature-compact-select
				.feature=${getFeature('LE_ColourTemperature_1', this.features)}
				.hideDisabled=${true}
				.productData=${getProductData('LE_ColourTemperature_1', this.productData)}>
			</feature-compact-select>
			<feature-compact-select
				.feature=${getFeature('LU_Battery', this.features)}
				.hideDisabled=${true}
				.productData=${getProductData('LU_Battery', this.productData)}>
			</feature-compact-select>
			<feature-compact-select
				.feature=${getFeature('HS_Construction', this.features)}
				.hideDisabled=${true}
				.productData=${getProductData('HS_Construction', this.productData)}>
			</feature-compact-select>
			<feature-compact-select
				.feature=${getFeature('HS_HousingSize', this.features)}
				.hideDisabled=${true}
				.productData=${getProductData('HS_HousingSize', this.productData)}>
			`,
		];
	}

	render() {
		return html`
			<div class="solarSettingsPanel">
				${this.widgets}
			</div>
		`;
	}
}
